import React, { FC, MouseEvent } from 'react';
import classnames from 'classnames';
import { DefaultPopover } from '../DefaultPopover';
import { ListPopoverProps } from './props';
import './styles.scss';

export const ListPopover: FC<ListPopoverProps> = ({ list, isShown, className, onItemClick }) => {
  return (
    <DefaultPopover className={classnames('fr-list-popover', className)} isShown={isShown}>
      {list.map((item, index) => {
        const { label, error: isError, destructive: isDestructive, disabled: isDisabled } = item;

        function handleItemClick(e: MouseEvent) {
          e.stopPropagation();

          if (!isDisabled && onItemClick) {
            onItemClick({ index, ...item });
          }
        }

        return (
          <div
            className={classnames(
              'fr-list-popover__item',
              (isError || isDestructive) && 'fr-list-popover__item--error',
              isDisabled && 'fr-list-popover__item--disabled',
            )}
            key={index}
            onClick={handleItemClick}
          >
            <span>{label}</span>
          </div>
        );
      })}
    </DefaultPopover>
  );
};
